var MDB = window.MDB || {};;
(function ($, global) {
    MDB.WidgetEditor = MDB.WidgetEditor || {};

    $.extend(MDB.WidgetEditor, {
        wirePreviewButton: function (model) {
            //var model = MDB.WidgetEditor.activeModel;

            // show preview sql
            if (!MDB.WidgetEditor.isDebug) {
                $('.preview-sql-box').remove();
            } else {
                $('body').bind('preview-sql', function (e) {
                    // preview query
                    $('.preview-sql').text('');
                    setTimeout(function () {

                        if (model.isValid()) {
                            var configuration = JSON.stringify(model.getData());
                            MDB.callApi({
                                url: 'WidgetController/PreviewQuery',
                                type: 'POST',
                                processData: false,
                                contentType: 'application/json',
                                data: configuration
                            }).done(function (sql) {
                                $('.preview-sql').text(sql);
                            });
                        }
                    }, 0);
                });
            }
            // preview button
            var previewBox = $('#widget-preview');
            var previewBoxHtml = previewBox.html();
            previewBox.hide();
            var activePreviewPromise = false;
            var widgetTypeSelector = $('.widget-settings .w-type');
            var currentWidgetType = -1;
            widgetTypeSelector.bind('change', function (e) {
                previewBox.hide();
            });

            var kendoConfig = {};
            $('#main-form-container .btn-preview').bind('click', function (e) {
                // If the Kendo settings part of the form is present, transform its inputs into a usable config object though the MVC model binder.
                var kendoSettings = $('.chart-settings');
                if (kendoSettings.is(':visible')) {
                    var kendoForm = $(this).closest('form');
                    if (kendoForm.valid()) {
                        $.ajax({
                            url: $(this).data('href'),
                            cache: false,
                            data: kendoForm.serialize(),
                            type: 'POST',
                            success: function (json) {
                                kendoConfig = json;
                            }
                        });
                    }
                }

                if (!model.isValid()) {
                    previewBox.hide();
                    return;
                }
                if (activePreviewPromise) {
                    activePreviewPromise.abort();
                }

                previewBox.data('reload', function () {
                    var data = previewBox.data('preview-data');
                    var rd = previewBox.data('renderdata');
                    if (rd && data) {
                        rd(data).done(function () {
                            previewBox.find('.chart').css('visibility', 'visible'); 
                        });
                    }
                });

                var configuration = JSON.stringify(model.getData());

                var columnAliasses = MDB.callApi({
                    cache: false,
                    url: 'WidgetController/GetColumnAliasses',
                    type: 'POST',
                    processData: false,
                    contentType: 'application/json',
                    data: configuration
                }).done(function (json) {
                    // update aliasses
                    previewBox.data('titles', JSON.stringify(json));
                }).fail(function (text) {
                    $('.preview-sql').text(text);
                });

                //$('#widget-preview')
                activePreviewPromise = MDB.callApi({
                    cache: false,
                    url: 'WidgetController/previewdata',
                    type: 'POST',
                    processData: false,
                    contentType: 'application/json',
                    data: configuration
                }).done(function (data) {
                    var selectedWidgetType = parseInt(widgetTypeSelector.val(), 10);
                    if (selectedWidgetType != currentWidgetType) {
                        // change the widget type
                        currentWidgetType = selectedWidgetType;
                        previewBox.html(previewBoxHtml);
                        previewBox.show();
                        MDB.Charts.register('preview', currentWidgetType, {});
                    } else {
                        previewBox.show();
                        previewBox.find('.chart').css('visibility', 'hidden');
                        //previewBox.find('.chart').hide();
                        //previewBox.find('.loading-box').show();
                    }
                    if (data && data.Metadata && data.DataTable) {
                        // convert to the same format as the dashboard uses
                        var meta = data.Metadata;
                        if (model.getColors().length !== 0) {
                            kendoConfig.seriesColors = model.getColors().map(function(color) {
                                return color.ColorValue;
                            });
                        }
                        meta.KendoConfig = kendoConfig;
                        data = data.DataTable;
                        data.metadata = meta;
                    }
                    previewBox.data('preview-data', data);
                    var rd = previewBox.data('renderdata');
                    if (rd && data) {
                        rd(data).done(function () {
                            previewBox.find('.chart').css('visibility', 'visible'); 
                        });
                    }
                }).always(function () {
                    activePreviewPromise = false;
                });
            });
        }
    });
})(jQuery, window);